import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logo1 from '../img/logo1.png';


// Futuristic styled components
const Title = styled.h1`
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  color: #00f2fe;
  text-shadow: 0 0 15px rgba(0, 242, 254, 0.7);
  font-family: 'Orbitron', sans-serif;
  letter-spacing: 2px;
  text-transform: uppercase;
  position: relative;
  z-index: 10;
  animation: textGlow 3s ease-in-out infinite alternate;
`;

const Subtitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 3rem;
  color: #a5b4fc;
  font-family: 'Rajdhani', sans-serif;
  letter-spacing: 1px;
  text-shadow: 0 0 10px rgba(165, 180, 252, 0.5);
`;

const SignInLink = styled(Link)`
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  color: #0a192f;
  padding: 15px 40px;
  text-decoration: none;
  font-size: 1.2rem;
  border-radius: 30px;
  font-family: 'Orbitron', sans-serif;
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 5px 25px rgba(0, 242, 254, 0.4);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 35px rgba(0, 242, 254, 0.6);
    color: #0a192f;
  }

  &:active {
    transform: translateY(0);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    z-index: -1;
    opacity: 0;
    transition: opacity 0.4s ease;
  }

  &:hover::before {
    opacity: 1;
  }
`;

const WelcomePage = () => {
  return (
    <div className='welcome-container'>
      {/* Particle Background - Add via CSS or a particle library */}
      <div className='particle-background'></div>
      
      <div className='content-wrapper'>
        <div className='logo-container'>
          <img src={logo1} alt='Eastern Pacific Academy Logo' className='holographic-logo' />
          <div className='logo-glow'></div>
        </div>
        
        <div className='text-content'>
          <Title>Eastern Pacific Academy</Title>
          <Subtitle>Learning to Serve</Subtitle>
          <SignInLink to="/signin">Access Portal</SignInLink>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;